export default __webpack_public_path__ + "static/media/im3.c76b9833.png";